import { Module } from "vuex";
import { DECLINED_TRANSACTIONS_ACTIONS, actions } from "./actions";
import { DECLINED_TRANSACTIONS_MUTATIONS, mutations } from "./mutations";
import { IDeclinedTransactionsState } from "./types";
import { IRootState } from "@/store/types";
import { cloneDeep } from "@/helpers/object";

export const state: IDeclinedTransactionsState = {
  declinedTransactionsList : [],
  totalDeclinedTranasctionCount: 0,
  declineCodes: [],
  hasSearchedForDeclinedTransactions: false,

  dataTables: {
    declinedTransactionsList: {
      declinedTransactionFilters: {
        cardNumber: undefined,
        childTerminalId: undefined
      },
      pagination: {
        page: 1,
        rowsPerPage: 10,
        descending: false
      }
    },
  }
};

export namespace DECLINED_TRANSACIONS {
  export const ACTIONS = DECLINED_TRANSACTIONS_ACTIONS;
  export const GETTERS = DECLINED_TRANSACTIONS_ACTIONS;
  export const MUTATIONS = DECLINED_TRANSACTIONS_MUTATIONS;
  export const NAME_SPACE = "declinedTransactions";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const declinedTransactions: Module<IDeclinedTransactionsState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  actions,
  mutations
};
